import * as React from "react";
import { DropzoneDialog } from "material-ui-dropzone";
import Button from "@material-ui/core/Button";

type Props = {
  onDrop: any;
  singleImage?: boolean;
};
const UploadImage = (props: Props) => {
  const { onDrop, singleImage } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="contained"
        color="primary"
        size="big"
      >
        ファイルを追加
      </Button>
      <DropzoneDialog
        dialogTitle={
          "ドラッグアンドドロップもしくはクリックしてファイルを追加してください。"
        }
        open={open}
        onSave={onDrop}
        showPreviews={true}
        maxFileSize={5000000}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default UploadImage;
